import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, Zap, Clock, TrendingUp } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HeroSection = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/contact/short`, {
        email: email,
        source: 'Homepage Hero'
      });

      if (response.data.status === 'success') {
        navigate('/success');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Tired of slow and outdated{' '}
              <span style={{ color: '#F97316', fontWeight: 'bold' }}>TS Practice CS</span>
              &nbsp;software?
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Practice Dashboard isn't a replacement for Practice CS—it's the perfect add-on to fill in the gaps, giving your firm the speed, flexibility, and quality you've been missing. Keep an eye on critical metrics for your firm, staff, and clients—all in one place.
            </p>
            
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center bg-green-100 text-green-800 px-4 py-2 rounded-full">
                <Zap className="w-4 h-4 mr-2" />
                <span className="font-medium">Efficient</span>
              </div>
              <div className="flex items-center bg-blue-100 text-blue-800 px-4 py-2 rounded-full">
                <Clock className="w-4 h-4 mr-2" />
                <span className="font-medium">Fast</span>
              </div>
              <div className="flex items-center bg-purple-100 text-purple-800 px-4 py-2 rounded-full">
                <TrendingUp className="w-4 h-4 mr-2" />
                <span className="font-medium">Modern</span>
              </div>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 italic text-lg">
                "It's the perfect solution for firms that want to modernize their practice management tool—without the cost of migrating to an entirely new system."
              </p>
            </div>
            
            <form onSubmit={handleSubmit} className="flex gap-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email..."
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                required
                disabled={isSubmitting}
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-6 py-3 bg-orange-500 hover:bg-orange-600 disabled:bg-gray-400 text-white font-semibold rounded-lg transition-colors"
              >
                {isSubmitting ? 'Submitting...' : 'Interested!'}
              </button>
            </form>
          </div>
          
          <div className="flex justify-center items-center">
            <img
              src="/Billing Worksheet.jpg"
              alt="Billing Worksheet Dashboard"
              className="max-w-full h-auto object-contain"
              style={{ maxHeight: '600px' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;